v-container
  //- Title and Description
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('authorization.title') }}
  //- Authorized Contacts Section
  v-row
    v-col(cols="12")
      h3.text-h5.mb-4 {{ $t('authorization.authorizedContacts.title') }}

  for contact, index in form.authorizedContacts
    ContactFields(:contact="contact")
  v-divider.my-6
  v-row
    v-col(cols="12")
      p.text-body-1.mb-4 {{ $t('authorization.description').replace("(patient name and date of birth)", `${patientForm.name} ${patientForm.dateOfBirth}`) }}

  v-divider.my-6

  //- Health Insurance Section
  v-row
    v-col(cols="12")
      h3.text-h5.mb-4 {{ $t('authorization.insurance.title') }}
  v-row
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.provider"
        :label="$t('authorization.insurance.provider')"
        :rules="[form.validCheck('provider')]"
      )
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.memberId"
        :label="$t('authorization.insurance.memberId')"
        :rules="[form.validCheck('memberId')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.subscriberName"
        :label="$t('authorization.insurance.subscriberName')"
        :rules="[form.validCheck('subscriberName')]"
      )
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.subscriberDob"
        :label="$t('authorization.insurance.subscriberDob')"
        type="date"
        :rules="[form.validCheck('subscriberDob')]"        
      )


  v-divider.my-6

  //- Legal Text
  v-row
    v-col(cols="12")
      p.text-body-2 {{ $t('authorization.legalText') }}

  v-divider.my-6

  //- Signature Section
  v-row
    v-col(cols="12")
      SignaturePad(
        v-model="form.signature"
        :label="$t('authorization.signature')"
        :rules="[form.validCheck('signature')]"
      )
